import { useCallback, useState } from 'react';
import { Box, Button } from '@betty/moonlight';
import { useDispatch } from '@betty/toolkit/state';
import { openDeposit, openWithdrawal } from '@betty/wallet';

function PaymentButtons() {
  const dispatch = useDispatch();
  const [withdrawLoading, setWithdrawLoading] = useState(false);

  const handleWithdraw = useCallback(async () => {
    setWithdrawLoading(true);

    await dispatch(openWithdrawal());

    setWithdrawLoading(false);
  }, [dispatch]);

  const handleDeposit = useCallback(() => {
    dispatch(openDeposit());
  }, [dispatch]);

  return (
    <Box
      flexDirection="row"
      gap="space-400"
      width="100%"
      paddingHorizontal="space-400"
      paddingVertical="space-400"
    >
      <Button
        variant="secondary"
        loading={withdrawLoading}
        onPress={handleWithdraw}
        locNS="account"
        locKey="withdraw"
        flex={1}
      />
      <Button
        variant="primary"
        onPress={handleDeposit}
        locNS="account"
        locKey="deposit"
        flex={1}
      />
    </Box>
  );
}

export default PaymentButtons;
